export const data = {
  experience: [
    {
      title: "Freelancer - Data & BI Analyst - ",
      company: "Self Employed",
      description:
        "Going freelance in 2023 was a deliberate choice — I wanted breadth across industries and depth across the modern data stack, on my own terms. Since then I've supported global clients across e-commerce (FMCG, wellness, beauty), care homes, finance and logistics, building Power BI dashboards on SQL, designing end-to-end Microsoft Fabric solutions (Data Factory, OneLake, Real-Time Analytics, Power BI) for an independent client, and running Python ML pipelines with scikit-learn, XGBoost and Prophet for forecasting and pattern discovery. Alongside the analytics, I've shipped automations using UiPath, Power Automate and VBA to reduce manual handling, and produced clear how-to guides so non-technical users can navigate the tools without me sitting next to them. The freelance lens has also kept me close to the parts of BI that often get overlooked — stakeholder translation, documentation and on-time delivery.",
      date: "01/2023 - Present",
    },

    {
      title: "Operations Support Assistant - ",
      company: "MSC",
      description:
        "I focused on generating daily and weekly KPIs alongside ad-hoc insight packs for Haulage, Container Movement, and Port Operations. I utilized SQL, Advanced Excel, and Power BI to cleanse and reconcile complex datasets to surface actionable trends. To improve team efficiency, I also introduced new templates and standard operating procedures using Excel and Power Query, and trained new hires on systems like Destin8 and PARIS.",
      date: "04/2022 - 11/2022",
    },

    {
      title: "Operation Analyst - ",
      company: "Synergen Health",
      description:
        "I specialized in optimizing the revenue cycle management process. I regularly pulled warehouse data using SQL, analyzed accounts receivable and claim denials in Excel, and built comprehensive Power BI dashboards. By automating reconciliations with VBA and leading collaborative fixes with operations, coding, and billing teams, I successfully helped cut down claim denials and reduced accounts receivable days.",
      date: "04/2019 - 02/2022",
    },
    {
      title: "Data Analyst -",
      company: "AFIT Connects",
      description:
        "At AFIT Connects, I worked as a Data Analyst supporting international accounting and consulting firms across the UK, Australia, New Zealand, Canada and the EU. My focus was turning complex financial datasets into clear, navigable Power BI dashboards, building Excel and SQL automations to streamline client workflows, and surfacing performance patterns clients had missed in their own reporting. A background in accounting (BBA, AAT Level 3, CERP) meant I could engage clients on what their data actually meant for their business.",
      date: "06/2017 - 03/2019 - Contract",
    },
  ],

  education: [
      {
      subject: "MSc in Data Science - ",
      institution: "Kingston University",
      description: "Part-time | Online | Self-paced Learning",
      courseWork: "Databases and Data Management | Data Analytics and Visualisation | Applied Data Programming | Machine Learning and Deep Learning | Project Dissertation",
      date: "09/2025 - 09/2026",
    },
    {
      subject: "Level 5 HND in Data Analytics - ",
      institution: "Pearson BTEC",
      description: "Completed",
      courseWork: "Programming, Networking, Professional Practice, Database Design and Development, Security, Planning A Computing Project (Pearson Set), Data Analytics, Maths for Computing, Computing Research Project (Pearson Set), Business Process Support, Advanced Programming for Data Analytics, Machine Learning, Big Data Analytics and Visualisation, Applied Analytics Models, Analytical Methods",
      date: "02/2023 - 03/2025",
    },
    {
      subject: "Data Science Bootcamp",
      institution: "HyperionDev / Imperial College London",
      description: "Achieved a grade of 100% with distinction, ranking 4th out of 980 students.",
      courseWork: "🐍 Python for Data Science: Pseudo-code & algorithms | Variables & data types | Control structures | Functions & recursion | Data structures (lists, dicts, 2D lists) | File I/O | OOP | Debugging | Intro to NLP | Core maths (discrete maths, calculus, statistics) | Capstone: calculator, file handling, OOP, NLP. 📊 Data Analytics & Exploration: Data sources (JSON, XML, CSV) | Databases (Relational, Graph, NoSQL) | SQL/MySQL | SQLite | Data viz (Matplotlib, Tableau, 3D plots) | Python packages (pandas, NumPy, SciPy) | Data cleaning & manipulation | Exploratory Data Analysis (GroupBy, correlation, ANOVA) | Capstone: database, analysis, full viz. 🤖 Machine Learning & AI: Intro to ML | Supervised: Linear & Logistic Regression, Decision Trees, Random Forests, Boosting | Unsupervised: Clustering (k-means, hierarchical), PCA | Neural nets (basics, backprop, validation) | Capstone: image recognition, unsupervised ML.",
      date: "02/2023 - 07/2023"
    },
    {
      subject: "AAT - ",
      institution:
        "AAT Sri Lanka",
      description: "Part Qualified - Level 3",
      date: "2018",
    },
    {
      subject: "BBA - ",
      institution:
        "Faculity of Management and Finance at University of Colombo",
      description: "Studied Business Administration and Finance",
      date: "2017",
    },
    {
      subject: "G.C.E. A/L",
      institution: "",
      description: "3 A’s for Accounting, Economics & Business Studies",
      date: "",
    },
    {
      subject: "G.C.E. O/L - ",
      institution: "",
      description: "4 A’s (Including Maths and Science), 2 B’s & 4 C’s",
      date: "",
    },
  ],
};
